import { jsx as _jsx } from "react/jsx-runtime";
import { Close } from "@air/next-icons";
import { IconButton } from "@air/primitive-icon-button";
import { SELECT_CHIP_REMOVE_BTN } from "~/components/Select/shared/testIDs";
export const SelectChipRemoveButton = (param)=>{
    let { chip, onClick } = param;
    return /*#__PURE__*/ _jsx(IconButton, {
        appearance: "ghost",
        color: "grey",
        className: "ml-0.5",
        "data-testid": "".concat(SELECT_CHIP_REMOVE_BTN, "-").concat(chip.label),
        icon: Close,
        label: "Remove chip",
        onClick: (event)=>{
            event.stopPropagation();
            onClick(chip);
        },
        size: "extra-small"
    });
};
